module.exports = __webpack_public_path__ + "img/22.9994785.png";